import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';
import {isArray, isBoolean, includes} from 'lodash';

@Directive({
  selector: ':not(jd-col)[col],jd-col,:not(jd-col)[jd-no-col],jd-col[jd-no-col]',
  host: {}
})

export class JdColDirective implements OnInit {
  private _forbid: any = false;
  private _noCol: any = false;

  @Input('jd-clear')
  set clear(value: any) {
    if (isArray(value)) {
      this._forbid = value;
    } else {
      this._forbid = value === '' || !(value === false || value === 'false');
    }
  }

  @Input('jd-no-col')
  set noCols(value: any) {
    this._noCol = value === '' || !(value === false || value === 'false');
  }

  get _cdColClass() {
    if (this._noCol) {
      return false;
    } else {
      return isBoolean(this._forbid) ? !this._forbid : isArray(this._forbid) ? includes(this._forbid, 'jd-col') : !this._forbid;
    }
  }

  constructor(private _el: ElementRef, private _renderer: Renderer2) {
  }

  ngOnInit() {
    if (this._cdColClass) {
      this._renderer.addClass(this._el.nativeElement, 'jd-col');
    } else {
      this._renderer.removeClass(this._el.nativeElement, 'jd-col');
    }

  }
}
